import React, { Component, ReactNode } from "react";
import Throbber from "./components/Throbber";
import CenterLayout from "./components/CenterLayout";

import { connect } from "react-redux";

import { AUTH_STATUS, UserState } from "../redux/modules/user/reducer";
import { GlobalState } from "../redux/modules/rootReducer";
import { userOpensBackofficeWebapp } from "./scenarios";
import { AppDispatch } from "../store";

interface IAuthProviderProps {
  dispatch: AppDispatch;
  user: UserState;
  children: ReactNode;
}

interface IAuthProviderState {
  pending: boolean;
}

class AuthProvider extends Component<IAuthProviderProps, IAuthProviderState> {
  state = {
    pending: true,
  };

  async componentDidMount() {
    await this.props.dispatch(userOpensBackofficeWebapp());
    this.setState({
      pending: false,
    });
  }

  render() {
    const { user, children } = this.props;
    const { pending } = this.state;

    if (user.status === AUTH_STATUS.AUTHORIZED) {
      return children;
    }

    if (pending) {
      return (
        <CenterLayout>
          <Throbber />
        </CenterLayout>
      );
    }

    return (
      <CenterLayout>
        <Throbber />
      </CenterLayout>
    );
  }
}

export default connect((state: GlobalState) => ({
  user: state.user,
}))(AuthProvider);
